{
  "otherOrganizations": "其他组织",
  "solutionIframe": "主要内容",
  "unloadPromptMessage": "是否确定？"
}
